import { TAB_HIDE, TAB_SHOW } from '../../../../../../common/tabs/tabs.constants';
import { template } from 'lodash';
import { GridController, gridTpl } from '../../../../../../common/grid/grid.controller';
import { IDS } from '../../../../pnp-docs/pnp-doc/pnp-doc.constants';
import { fetchEvidenceGroupRequirementsGrid } from '../../pnp-doc.actions';

class PnpDocSectionsGridController extends GridController {
    constructor($ngRedux, $state, NavigationService, $filter, $mdDialog, $scope) {
        super($ngRedux, $state, NavigationService, $filter, $mdDialog);
        this.$scope = $scope;
    }

    $onInit() {
        this.module = 'policies';
        this.identifier = IDS.pnpDocSectionsGrid;
        this.statePath = IDS.pnpDocument;
        this.filterComponent = false;
        this.exportComponent = false;
        this.confirmDialogOnRemove = true;
        this.icon = false;

        this.columns = [
            {title: this.$filter('translate')('ACCREDITATION.COMMON.APPLICABLE_REQUIREMENTS'),  mapper: 'name'},
        ];

        this.unsubscribe = this.$ngRedux.connect(
            this.mapState().bind(this),
            { 
                 fetchEvidenceGroupRequirementsGrid 
            }
        )(this);
        this?.init()
    }

    // Implement or override `dataAction`
    getItems() {
        return fetchEvidenceGroupRequirementsGrid(); // Fetch items for the grid
    }

    $onDestroy() {
        this.destroy();
    }
}

PnpDocSectionsGridController.$inject = ['$ngRedux', '$state', 'NavigationService', '$filter', '$mdDialog', '$scope'];

export const pnpDocSectionsGrid = {
    bindings: {
        title: '@',
        onRemove: '&',
    },
    controller: PnpDocSectionsGridController,
    ...gridTpl
}
